import Icon from "@expo/vector-icons/MaterialIcons";
import Button from "@src/components/button/Button04";
import { useAppSelector } from "@src/ducks/ducksHook";
import { useDashboardService } from "@src/ducks/hooks";
import { useFetchGet } from "@src/utils/api/hooks";
import { selectIsFreePlan, selectSubscriptionActive, selectSubscriptionExpiration, selectSubscriptionFullSlot, selectSubscriptionMaxUsers, selectSubscriptionRole } from "@src/ducks/slices/user.slice";
import React from "react";
import { View, Text } from "react-native";
import { DrawerContext } from "../../drawer-provider";
import useStyles from "./styles.css";
import BannerModal from "../../../dashboard/banner-new/banner-modal";
import _100Mb_Modal from "./modals/100mb-status";

const getButtonLabel = (title: string) => {
  switch(title){
  case "Signatures":
    return "Upload Signature";
  case "Manage Users":
    return "Invite User";
  case "Inbox":
    return "Create Message";
  case "Dashboard":
  case "Documents":
  default:
    return "Upload Document";
  }
};

const CreateButton = () => {
  const styles = useStyles();
  const { onDrawerEnable } = useDashboardService();
  const maxUser = useAppSelector(selectSubscriptionMaxUsers);
  const fullSlot = useAppSelector(selectSubscriptionFullSlot);
  const subscriptionRole = useAppSelector(selectSubscriptionRole);
  const isSubscribeActive = useAppSelector(selectSubscriptionActive);
  const isFreePlan = useAppSelector(selectIsFreePlan);
  const isNotExpired = useAppSelector(selectSubscriptionExpiration);
  const { activeTab, onActiveTab, onSetActiveSecondScreen, onAddTeamButton } = React.useContext(DrawerContext);
  const ButtonLabel = React.useMemo(() => getButtonLabel(activeTab), [activeTab]);
  const [showModal, setShowModal] = React.useState(false);
  const [show100MbModal, setShow100MbModal] = React.useState(false);
  let shouldShowCreateButton = true;


  const { loading, data, runRequest } = useFetchGet();

  React.useEffect(() => {
    const responseObject = data?.data;
    if (responseObject) {
      if (Math.round(responseObject.usedStorage) < responseObject.totalStorage) {
        onActiveTab("Create Document");
      }
      else {
        setShow100MbModal(true);
      }
    }
  }, [data]);

  const onVerifyUpload = React.useCallback(() => {
    runRequest("/directory/verify-upload-ability");
  }, []);


  const onPress = React.useCallback(() => {
    switch(activeTab){
    case "Signatures":
      onSetActiveSecondScreen("signature-upload");
      break;
    case "Manage Users":
      onAddTeamButton(true);
      break;
    case "Dashboard":
    case "Documents":
    case "Support":
    case "Document Sent":
      // onDrawerEnable(false);
      if (isFreePlan) {
        onVerifyUpload();
      }
      else {
        onActiveTab("Create Document");
      }
      break;
    }
  }, [isFreePlan, activeTab, onVerifyUpload]);

  const onUpgrade = React.useCallback(() => {
    setShowModal(true);
  }, []);

  if(activeTab === "Manage Users"){
    shouldShowCreateButton = false;
  }

  if(isNotExpired && !isSubscribeActive){
  }
  else if(!isSubscribeActive && ["Dashboard", "Documents", "Manage Users"].includes(activeTab)){
    //shouldShowCreateButton = false
  }else if(!["Owner", "Admin"].includes(subscriptionRole) && ["Manage Users"].includes(activeTab)){
    shouldShowCreateButton = false;
  }else if(maxUser <=1 && ["Manage Users"].includes(activeTab)){
    shouldShowCreateButton = false;
  }else if(fullSlot && ["Manage Users"].includes(activeTab)){
    shouldShowCreateButton = false;
  }else if (activeTab === "Inbox"){
    shouldShowCreateButton = false;
  }else if (activeTab === "SafeForm Lite"){
    shouldShowCreateButton = false;
  }else if (activeTab === "Document Sent"){
    shouldShowCreateButton = false;
  }else if (["Get Free Trial"].includes(activeTab)){
    shouldShowCreateButton = false;
  }else if (["Support"].includes(activeTab)){
    shouldShowCreateButton = false;
  }
  
  if(isSubscribeActive){
  } else if( activeTab === "Inbox"){
    shouldShowCreateButton = false;
  }

  return shouldShowCreateButton ? (
    <>
      {loading && <Button isLoading={loading} style={styles.btn_createdocument} /> }
      {!loading &&
        <Button
          onPress={onPress}
          style={styles.btn_createdocument} >
          <>
            <Text style={styles.btn_label}>{ButtonLabel}</Text>
            {ButtonLabel !== "Upload Document" &&
                    <Icon name="add" size={15} color="white" />
            }
          </>
        </Button>
      }
      <_100Mb_Modal visible={show100MbModal}
        onProceed={() => onActiveTab("Upgrade Plan")}
        onClose={() => setShow100MbModal(false)} />
    </>
  ) : ["Dashboard"].includes(activeTab) ? (
    <>
      <Button
        onPress={onUpgrade}
        style={styles.disabled_createdocument} >
        <>
          <Text style={styles.btn_label}>{ButtonLabel}</Text>
          {/* <Icon name="add" size={15} color="white" /> */}
        </>
      </Button>
      <BannerModal visible={showModal} onBack={() => setShowModal(false)} />
    </>
  ) : <></>;
};

export default CreateButton;
